import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z"
}), 'ClearAllSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ClearAllSharp.js
// module id = 2812
// module chunks = 2